export default "__VITE_ASSET__d5cfc19a__"